import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function EditCategory() {
  const { state: category } = useLocation();
  const [categoryName, setCategoryName] = useState(
    category ? category.categoryName : ""
  );
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(category?.catimg || ""); // Existing image URL

  const navigate = useNavigate();

  const handleUpdate = async () => {
    if (!categoryName.trim()) {
      toast.error("Please enter a category name.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("categoryName", categoryName);
      if (image) {
        formData.append("catimg", image);
      }

      const response = await axios.patch(
        `http://visit.visitguru.inhttps://visitguru.in/api/v1/category/editCategory/${category._id}`,
        formData
      );

      if (response.status === 200 || response.data.success) {
        toast.success("Category updated successfully!");
        navigate("/admin/category");
      } else {
        toast.error(response.data.message || "Update failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update category.");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Edit Category</h6>
        </div>
      </div>

      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* Category Name */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Category Name
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Category Name"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
            />
          </div>

          {/* Existing Image Preview */}
          {previewImage && (
            <div className="mb-4">
              <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                Current / Selected Image
              </label>
              <img
                src={previewImage}
                alt="Current"
                className="w-12 h-12 object-cover rounded mt-2 border"
              />
            </div>
          )}

          {/* Upload New Image */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Upload New Category Image
            </label>
            <input
              type="file"
              accept="image/*"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              onChange={handleImageChange}

            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end mt-8">
            <button
              type="button"
              onClick={() => navigate("/admin/category")}
              className="bg-red-500 hover:bg-red-600 text-white font-bold uppercase text-xs px-6 py-3 rounded shadow focus:outline-none focus:ring-2 focus:ring-red-400 transition-all duration-150 mr-4"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleUpdate}
              className="bg-lightBlue-500 hover:bg-lightBlue-600 text-white font-bold uppercase text-xs px-6 py-3 rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-150"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditCategory;
